import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import PropertyMapss from "./PropertyMaps";
import httpCommon from "../../http-common";
import Container from "../../component/Container";
import AdvancedSearch from "../../component/searchBar/AdvancedSearch";
import PropertyCard from "../../component/card/PropertyCard";
import Social from "../../component/Social";
import { FaSellsy } from "react-icons/fa6";
import { MdAddHome } from "react-icons/md";
import { IoMdHappy } from "react-icons/io";
import { FaRegHandshake } from "react-icons/fa";
import { FaWhatsapp } from 'react-icons/fa';
import Loader from "../../component/Loader/Loader";

function PropertyQuery() {
    const [allProperties, setAllProperties] = useState([]);
    const defaultCenter = {
        lat: 12.9716,
        lng: 77.5946,
    };

    const [originalProperties, setOriginalProperties] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedProperties, setSelectedProperties] = useState([]);
    const [mapProperties, setMapProperties] = useState([]);
     const [searchCenter, setSearchCenter] = useState(null);
     const mapSearchRef = useRef({
        searchLat: null,
        searchLng: null,
    });

    const location = useLocation();
    const query = location.state?.query || "";
    const query2 = location.state?.data || "";

    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);

    const [searchData, setSearchData] = useState(query2 || {});
    const [loadingMore, setLoadingMore] = useState(false);
    const loadMoreRef = useRef(null);
    const [soldProperties, setSoldProperties] = useState([]);
    const displayProperties = hasMore
        ? allProperties
        : [...allProperties, ...soldProperties];

    console.log("filterParams____query2",query2);

     const center = { lat: 12.9716, lng: 77.5946 };
    
     const getSearchCoordinates = (data = {}) => {
        if (!data || typeof data !== "object") {
            return null;
        }

        let lat =
            data.searchLat ??
            data.latitude ??
            data.lat ??
            data.location?.searchLat ??
            data.location?.latitude ??
            data.location?.lat;

        let lng =
            data.searchLng ??
            data.longitude ??
            data.lng ??
            data.location?.searchLng ??
            data.location?.longitude ??
            data.location?.lng;

        if (
            lat === undefined ||
            lat === null ||
            lng === undefined ||
            lng === null
        ) {
            return null;
        }

        lat = Number(lat);
        lng = Number(lng);

        if (
            Number.isNaN(lat) ||
            Number.isNaN(lng)
        ) {
            return null;
        }

        return {
            lat,
            lng,
        };
    };

    const fetchMapProperties = async ({
        searchData = {},
        searchLat,
        searchLng,
    } = {}) => {
        try {
            /*
             * Coordinates are required for Map API.
             */
            if (
                searchLat === undefined ||
                searchLat === null ||
                searchLng === undefined ||
                searchLng === null
            ) {
                console.log(
                    "MAP API skipped - coordinates not available"
                );

                setMapProperties([]);
                setSearchCenter(null);

                return;
            }

            const lat = Number(searchLat);
            const lng = Number(searchLng);

            /*
             * Validate coordinates.
             */
            if (
                Number.isNaN(lat) ||
                Number.isNaN(lng)
            ) {
                console.log(
                    "MAP API skipped - invalid coordinates"
                );

                setMapProperties([]);
                setSearchCenter(null);

                return;
            }

            /*
             * Store latest coordinates.
             */
            mapSearchRef.current = {
                searchLat: lat,
                searchLng: lng,
            };

            /*
             * Update map center.
             */
            setSearchCenter({
                lat,
                lng,
            });

            /*
             * Remove coordinate fields from filters.
             *
             * We send coordinates separately.
             */
            const {
                searchLat: _searchLat,
                searchLng: _searchLng,
                latitude: _latitude,
                longitude: _longitude,
                lat: _lat,
                lng: _lng,
                ...filters
            } = searchData || {};

            /*
             * Debug API request.
             */
            console.log(
                "MAP API REQUEST____",
                {
                    ...filters,
                    searchLat: lat,
                    searchLng: lng,
                    radiusKm: 15,
                }
            );

            /*
             * Call Map API.
             */
            const res = await httpCommon.get(
                "/list/map/search",
                {
                    params: {
                        ...filters,
                        searchLat: lat,
                        searchLng: lng,
                        radiusKm: 15,
                    },
                }
            );

            console.log(
                "MAP API RESPONSE____",
                res
            );

            /*
             * Handle successful response.
             */
            if (
                res.data?.status === "success"
            ) {
                const mapData =
                    res.data?.data || [];

                console.log(
                    "MAP PROPERTIES____",
                    mapData
                );
                

                setMapProperties(mapData);
            } else {
                setMapProperties([]);
            }

        } catch (error) {
            console.error(
                "MAP API ERROR____",
                error
            );

            setMapProperties([]);
        }
    };
    
    //const [selectedProperties, setSelectedProperties] = useState([]);

  // Function to handle new search from AdvancedSearch component
    const handleAdvanceSearch = (data) => {
        console.log("Advanced Search Data from Property page:", data);
        // Update the filtering with new search data
       // fetchAllProperties({}, data);
       setSearchData(data);
       setPage(1);
        setHasMore(true);
        setAllProperties([]);
        setSoldProperties([]);

        const coordinates =
            getSearchCoordinates(data);

        if (coordinates) {
            console.log(
                "SEARCH COORDINATES____",
                coordinates
            );

            /*
             * Call separate Map API.
             */
            fetchMapProperties({
                searchData: data,
                searchLat: coordinates.lat,
                searchLng: coordinates.lng,
            });
        } else {
            console.log(
                "No search coordinates available for Map API"
            );

            /*
             * Clear old map data.
             */
            setMapProperties([]);
            setSearchCenter(null);
        }



        fetchAllProperties({
            page: 1,
            searchData: data,
            isLoadMore: false,
        });
    };

 const convertBudgetStringToNumber = (str) => {
  if (!str) return 0;

  // If the value is already a number, return as-is in rupees
  if (typeof str === 'number') return str * 100000; // Assuming number is in LAC

  const [amount, unit] = str.toUpperCase().split(" ");
  const num = parseFloat(amount);

  if (unit === "LAC" || unit === "LACS") return num * 100000;
  if (unit === "CR" || unit === "CRS") return num * 10000000;

  return num; // fallback
};

    const fetchAllProperties = async ({
    page = 1,
    searchData = {},
    isLoadMore = false,
    } = {}) => {

    if (isLoadMore) setLoadingMore(true);
    else setLoading(true);

    try {
        const res = await httpCommon.get("/list/search", {
        params: {
            ...searchData,
            page,
            limit: 10,
        },
        });
        console.log("res____",res);
        if (res.data.status === "success") {

       let newData = res.data.data;
        const available = newData.filter(
        item => Number(item.ltg_det_sold_type) !== 1
        );

        const sold = newData.filter(
        item => Number(item.ltg_det_sold_type) === 1
        );
        //  SORT: available first (0), sold last (1)
        // newData = newData.sort((a, b) => {
        //     return Number(a.ltg_det_sold_type) - Number(b.ltg_det_sold_type);
        // });

        //  no more data
        if (newData.length < 10) {
            setHasMore(false);
        }

        //  first load / new search
        if (!isLoadMore) {
            //setAllProperties(newData);
             setAllProperties(available);
            setSoldProperties(sold);
        }
        //  append on scroll
        else {
            //setAllProperties(prev => [...prev, ...newData]);
            setAllProperties(prev => [...prev, ...available]);
            setSoldProperties(prev => [...prev, ...sold]);
        }
        }

    } catch (err) {
        console.error("API error:", err);
    } finally {
        setLoading(false);
        setLoadingMore(false);
    }
    };

    useEffect(() => {

    if (!hasMore || loadingMore) return;

    const observer = new IntersectionObserver(
        (entries) => {
        if (entries[0].isIntersecting) {

            const nextPage = page + 1;
            setPage(nextPage);

            fetchAllProperties({
            page: nextPage,
            searchData: searchData || {},
            isLoadMore: true,
            });
        }
        },
        { threshold: 1 }
    );

    if (loadMoreRef.current) {
        observer.observe(loadMoreRef.current);
    }

    return () => observer.disconnect();

    }, [page, hasMore, loadingMore, searchData]);


    const getSalePrice = (item) => {
        switch (item.ltg_type) {
            case "CommercialProperties":
                return item.ltg_det_comm_prop_sale_price;
            case "PentHouses":
                return item.ltg_det_penthouses_sale_price;
            case "RowHouses":
                return item.ltg_det_row_house_sale_price;
            case "Plots":
                return item.ltg_det_plot_sale_price;
            case "Villaments":
                return item.ltg_det_villaments_sale_price;
            default:
                return item.ltg_det_sale_price;
        }
    };

    const getArea = (item) => {
        switch (item.ltg_type) {
            case "CommercialProperties":
                return item.ltg_det_comm_prop_pmts_area_dts?.match(/(\d+)/)?.[0];
            case "PentHouses":
                return item.ltg_det_penthouses_pmts_area_dts?.match(/(\d+)/)?.[0];
            case "RowHouses":
                return item.ltg_det_row_house_pmts_area_dts?.match(/(\d+)/)?.[0];
            case "Plots":
                return item.ltg_det_plot_pmts_area_dts?.match(/(\d+)/)?.[0];
            case "Villaments":
                return item.ltg_det_villaments_pmts_area_dts?.match(/(\d+)/)?.[0];
            default:
                return item.ltg_det_pmts_area_dts?.match(/(\d+)/)?.[0];
        }
    };

    const getBedrooms = (item) => {
        switch (item.ltg_type) {
            case "PentHouses":
                return item.ltg_det_penthouses_pmts_bed_rooms;
            case "RowHouses":
                return item.ltg_det_row_house_pmts_bed_rooms;
            case "Villaments":
                return item.ltg_det_villaments_pmts_bed_rooms;
            default:
                return item.ltg_det_pmts_bed_rom;
        }
    };

    const getBathrooms = (item) => {
        switch (item.ltg_type) {
            case "PentHouses":
                return item.ltg_det_penthouses_pmts_bath_rooms;
            case "RowHouses":
                return item.ltg_det_row_house_pmts_bath_rooms;
            case "Villaments":
                return item.ltg_det_villaments_pmts_bath_rooms;
            default:
                return item.ltg_det_pmts_bth_rom;
        }
    };

    const getStatus = (item) => {
        switch (item.ltg_type) {
            case "CommercialProperties":
                return item.ltg_det_comm_prop_pmts_status;
            case "PentHouses":
                return item.ltg_det_penthouses_pmts_status;
            case "RowHouses":
                return item.ltg_det_row_house_pmts_status;
            case "Plots":
                return item.ltg_det_plot_pmts_status;
            case "Villaments":
                return item.ltg_det_villaments_pmts_status;
            default:
                return item.ltg_det_pmts_status;
        }
    };

    const getAmenities = (item) => {
        switch (item.ltg_type) {
            case "CommercialProperties":
                return item.ltg_det_comm_prop_amenities?.split(', ').map((amenity) => amenity.trim());
            case "PentHouses":
                return item.ltg_det_penthouses_amenities?.split(', ').map((amenity) => amenity.trim());
            case "RowHouses":
                return item.ltg_det_row_house_amenities?.split(', ').map((amenity) => amenity.trim());
            case "Plots":
                return item.ltg_det_plot_amenities?.split(', ').map((amenity) => amenity.trim());
            case "Villaments":
                return item.ltg_det_villaments_amenities?.split(', ').map((amenity) => amenity.trim());
            default:
                return item.ltg_det_amenities?.split(', ').map((amenity) => amenity.trim());
        }
    };

useEffect(() => {
    setPage(1);
    setHasMore(true);

    const initialSearchData = query2 || {};

    console.log(
        "PROPERTY QUERY INITIAL SEARCH DATA____",
        initialSearchData
    );

    // ==========================================
    // 1. Existing Listing API
    // ==========================================
    fetchAllProperties({
        page: 1,
        searchData: initialSearchData,
        isLoadMore: false,
    });

    // ==========================================
    // 2. Get search coordinates
    // ==========================================
    const coordinates = getSearchCoordinates(initialSearchData);

    console.log(
        "PROPERTY QUERY INITIAL COORDINATES____",
        coordinates
    );

    // ==========================================
    // 3. Call Map API on initial page load
    // ==========================================
    if (coordinates) {
        fetchMapProperties({
            searchData: initialSearchData,
            searchLat: coordinates.lat,
            searchLng: coordinates.lng,
        });
    } else {
        console.log(
            "PROPERTY QUERY INITIAL MAP API SKIPPED - NO COORDINATES"
        );

        setMapProperties([]);
        setSearchCenter(null);
    }
}, []);

    
const formatPrice = (num) => {
  if (!num || isNaN(num)) return "Price not available";

  const value = Number(num);

  if (value >= 10000000) { 
    // Crore
    return (value / 10000000).toFixed(2) + " Cr";
  } else if (value >= 100000) { 
    // Lakh
    return (value / 100000).toFixed(2) + " Lakh";
  } else if (value >= 1000) { 
    // Thousand
    return (value / 1000).toFixed(2) + " Thousand";
  } else {
    return value.toFixed(2);
  }
};

const handleShareWhatsApp = () => {
  const selectedItems = displayProperties.filter((item) =>
   // selectedProperties.includes(item.RowID)
  selectedProperties.includes(String(item.RowID))
  );

//console.log("selectedItems___",selectedItems);

  let message = "🏡 *Check out these properties:*\n\n";

  selectedItems.forEach((item, index) => {
    const projectName = item.ltg_projectName || "Project Name";
    const title = item.ltg_title || "Title";
   // const price = item.ltg_det_plot_sale_price || item.ltg_det_sale_price || item.ltg_det_call_for_price || "Price not available";
    const rawPrice = item.ltg_det_plot_sale_price || item.ltg_det_sale_price || item.ltg_det_call_for_price;
    const price = formatPrice(rawPrice);

    const location =
      item.ltg_det_plot_location || item.ltg_det_location || "Location not available";
      const cleanedPath = item.propertyUrl?.startsWith("/") 
  ? item.propertyUrl.slice(1) 
  : item.propertyUrl;

  const url = cleanedPath 
  ? `${window.location.origin}/Property/${cleanedPath}` 
  : window.location.href;

    message += `*${index + 1}. ${projectName}*\n`;
    message += `${title}\n`;
    message += `💰 Price: ${price}\n`;
    message += `📍 Location: ${location}\n`;
    message += `🔗 Link: ${url}\n\n`;
  });

  const encodedMessage = encodeURIComponent(message);
  const whatsappUrl = `https://wa.me/?text=${encodedMessage}`;
  window.open(whatsappUrl, "_blank");
};

// {console.log("allProperties___",allProperties)}
    return (
        <>
            <Container>
                
                <div style={{ marginTop: "30px",marginBottom: "10px" }}>
                 <AdvancedSearch
                    propertyTypes={["Apartments", "Villas", "Plots", "Row Houses", "Villaments", "Commercial Properties", "Pent Houses"]}
                    budgets={[5, 10, 20, 30, 40, 50, 75, 100, 200, 300, 400, 500, 750, 1000, 1500, 2000]}
                     onSearch={handleAdvanceSearch}
                    // defaultValues={query2}
                    defaultValues={searchData}
                />
               
                 <PropertyMapss 
                 properties={mapProperties} 
                  center={searchCenter || defaultCenter}
                  zoom={12}
                 options={{
                    fullscreenControl: true,
                    mapTypeControl: false,
                    streetViewControl: false,
                    zoomControl: true,
                }}
                />
                </div>
                {selectedProperties.length > 0 && (
                    <div style={{ margin: "5px 0" ,textAlign:"right"}}>
                        <button
                        variant="contained"
                        color="success"
                        
                        onClick={handleShareWhatsApp}
                        >
                        Share via WhatsApp ({selectedProperties.length})
                        </button>
                    </div>
                    )}

                {loading ? <Loader /> : (
                    displayProperties.map((item,index) => (
                        
                        <PropertyCard
                          key={String(item.RowID)}
                          item={item}
                          index={index}
                            />
                    ))
                )}

                {/*  Scroll trigger */}
                {hasMore && <div ref={loadMoreRef} style={{ height: "40px" }} />}

                {loadingMore && <Loader />}

                {!hasMore && (
                <div style={{ textAlign: "center", margin: "15px 0", fontWeight: "bold" }}>
                    No more records
                </div>
                )}
               
            </Container>

            <section className="footerPatner  bg-[#1C1C1E] ">
                <Container
                    className={
                        "md:py-20 flex flex-col md:flex-row items-center justify-between"
                    }
                >
                    <div className="w-full left md:w-1/2 md:pr-10">
                        <h2 className="mb-4 text-4xl font-bold text-white md:text-5xl">
                            More than 10 Years of Experience
                        </h2>
                        <hr className="w-20 h-1 mb-4 bg-blue-800" />
                        <p className="text-white">
                            It’s not what we do, but how we do it that sets us apart. Get in
                            touch with us today to experience our holistic services that will
                            put you a step closer to your dream home.
                        </p>
                    </div>
                    <div className="grid w-full grid-cols-1 mt-10 right md:w-1/2 md:grid-cols-2 gap-7 md:mt-0">
                        <div className="flex items-center gap-5 1">
                            <FaSellsy className="text-blue-700" size={42} />
                            <div>
                                <h2 className="text-white price">3500 +</h2>
                                <p className="text-white description">Properties Sold</p>
                            </div>
                        </div>
                        <div className="flex items-center gap-5 2">
                            <MdAddHome className="text-blue-700" size={42} />
                            <div>
                                <h2 className="text-white price">230 +</h2>
                                <p className="text-white description">Projects Handled</p>
                            </div>
                        </div>
                        <div className="flex items-center gap-5 3">
                            <IoMdHappy className="text-blue-700" size={42} />
                            <div>
                                <h2 className="text-white price">400 +</h2>
                                <p className="text-white description">NRI Clients Served</p>
                            </div>
                        </div>
                        <div className="flex items-center gap-5 3">
                            <FaRegHandshake className="text-blue-700" size={42} />
                            <div>
                                <h2 className="text-white price">40 +</h2>
                                <p className="text-white description">Builders, Marketing Partners</p>
                            </div>
                        </div>
                    </div>
                </Container>

                <hr className="" />
            </section>
            <Social />
        </>
    );
}

export default PropertyQuery;
